import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/eu-finance.png")